import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { hideErrorToast } from '@/features/ui/uiSlice';

export default function ErrorToast() {
  const { t } = useTranslation();
  const toast = useAppSelector((s) => s.ui.errorToast);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => dispatch(hideErrorToast()), 4000);
    return () => clearTimeout(id);
  }, [toast, dispatch]);

  if (!toast) return null;
  return (
    <div
      role="alert"
      className="fixed bottom-6 end-6 z-[10000] bg-hot-pink text-paper font-mono px-4 py-3 border-2 border-ink shadow-stamp max-w-sm"
    >
      <button
        type="button"
        onClick={() => dispatch(hideErrorToast())}
        className="absolute -top-2 -right-2 w-6 h-6 bg-paper border-2 border-ink text-ink font-display text-sm flex items-center justify-center"
        aria-label={t('cart.close')}
      >×</button>
      {toast.message}
    </div>
  );
}
